import { Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight';
import { ExpandingContent } from './ExpandingContent';
import { ShoppingWithSocial } from './ShoppingWithSocial';
import styles from './styles/ShoppingWithMobileDescription.scss';

const MAX_CHARACTER_LENGTH = 300;

function ShoppingWithMobileDescriptionComponent({ shoppingWith, onOpenAllShoppers }) {
    const shoppingWithDescription = shoppingWith.description || '';
    const isLongerThanMax = shoppingWithDescription.length > MAX_CHARACTER_LENGTH;
    return (
        <ExpandingContent
            startExpanded
            expandingChildren={({ isExpanded }) => {
                const description =
                    isLongerThanMax && !isExpanded
                        ? shoppingWithDescription.substr(0, MAX_CHARACTER_LENGTH) + '...'
                        : shoppingWithDescription;
                return (
                    <div className={styles.description}>
                        <span dangerouslySetInnerHTML={{ __html: description }} />
                        {!!isExpanded && (
                            <ul className={styles.list}>
                                {(get(shoppingWith, 'links.links') || []).map(({ label, url }) => (
                                    <li key={url} className={styles.mobileLinkItem}>
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            href={url}
                                            className={styles.mobileLink}
                                        >
                                            {label}
                                        </a>
                                    </li>
                                ))}
                                <li className={styles.mobileLinkItem}>
                                    <a
                                        href="#"
                                        className={styles.mobileLink}
                                        onClick={onOpenAllShoppers}
                                    >
                                        <FormattedMessage
                                            id="ShoppingWithMobileDescription.seeMoreShoppers"
                                            defaultMessage="See More Shoppers"
                                        />{' '}
                                        <ArrowRight className={styles.seeMoreIcon} />
                                    </a>
                                </li>
                            </ul>
                        )}
                    </div>
                );
            }}
        >
            {({ isExpanded, onToggleExpanded, icon, expandingContent }) => (
                <Fragment>
                    {expandingContent}
                    <a className={styles.toggleLink} href="#" onClick={onToggleExpanded}>
                        {isExpanded ? (
                            <FormattedMessage
                                id="ShoppingWithMobileDescription.less"
                                defaultMessage="Read Less"
                            />
                        ) : (
                            <FormattedMessage
                                id="ShoppingWithMobileDescription.continueReading"
                                defaultMessage="Continue Reading"
                            />
                        )}{' '}
                        {icon}
                    </a>
                    <div className={styles.socialWrapperMobile}>
                        <ShoppingWithSocial shoppingWith={shoppingWith} />
                    </div>
                </Fragment>
            )}
        </ExpandingContent>
    );
}

ShoppingWithMobileDescriptionComponent.propTypes = {
    shoppingWith: PropTypes.object.isRequired,
    onOpenAllShoppers: PropTypes.func.isRequired,
};

export const ShoppingWithMobileDescription = createFragmentContainer(
    ShoppingWithMobileDescriptionComponent,
    {
        shoppingWith: graphql`
            fragment ShoppingWithMobileDescription_shoppingWith on ShoppingWith {
                ...ShoppingWithSocial_shoppingWith
                description
                links {
                    links {
                        url
                        label
                    }
                }
            }
        `,
    }
);
